module.exports = __webpack_public_path__ + "static/media/CREDC-01.a818658a.svg";